import {
  IEntry,
  IModelFeatureCollection as IContentfulFeatureCollection,
  IModelFeatureCollection,
} from 'marketing-site/@types/generated/contentful'
import { IFeature, transformFeature } from './ContentfulFeature'

export interface IFeatureCollection {
  title: string
  items: IFeature[]
}

export function isFeatureCollection(entry: IEntry): entry is IModelFeatureCollection {
  return entry.sys.contentType?.sys.id === 'modelFeatureCollection'
}

export function transformFeatureCollection({
  fields,
}: IContentfulFeatureCollection): IFeatureCollection {
  return {
    ...fields,
    items: fields.items.map((item) => transformFeature(item)),
  }
}
